module.exports = __webpack_public_path__ + "img/jidi.46b3c828.jpg";